<template>
  <div class="h-11/12">
    <pl-spinner v-if="loading" style="margin: 100px auto" />
    <div v-else>
      <div class="w-full bg-gray-100 text-sm text-gray-700 px-4 py-3 rounded mb-3">
        <div class="flex items-center">
          <i class="fa-solid fa-circle-info text-2xl mr-4"></i>
          <div>
            <p class="mb-0.5">
              You can connect your <span class="font-semibold">Parlay account</span> to your account from a Learning Managing System at the school/district.
            </p>
            <p> A course can only have <span class="font-semibold">one connection</span> for each LMS.</p>
          </div>
        </div>
      </div>
      <div>
        <IntegrationCard
          :title="google_classroom_title"
          :icon="google_classroom_icon"
          :code="google_classroom_code"
          :memberships="memberships"
          type="connect"
        />
      </div>
      <!-- <div v-for="(integration, key) in getProviders" v-bind:key="key">
        <IntegrationCard
          :integration="integration"
          @updateRoster="updateRoster"
          :title="integration.name"
          :icon="integration.icon_url"
          :code="integration.id"
          :memberships="memberships"
          type="connect"
        />
      </div> -->
    </div>
    <integration-modal
      v-if="show_integration_modal"
      @close="closeIntegrationModal"
      :provider="provider_selected"
      :courses="provider_courses"
    />

    <google-classroom-modal
      v-if="google_classroom_modal"
      :courses="courses"
      @close="google_classroom_modal = false"
    />
    <disconnect-google-classroom-modal
      v-if="show_disconnect_classroom_modal"
      @close="show_disconnect_classroom_modal = false"
    />

    <integration-teacher-not-in-course-modal
      v-if="
        co_teachers_integration &&
        co_teachers_integration.teachers &&
        co_teachers_integration.teachers.length
      "
      :integration="co_teachers_integration"
      @close="co_teachers_integration = null"
    />
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import googleClassroomModal from 'components/modals/googleClassroomModal';
  import disconnectGoogleClassroomModal from 'components/modals/disconnectGoogleClassroomModal';
  import IntegrationCard from 'features/courses/components/integrationCard.vue';
  import integrationModal from 'components/modals/integrationModal';
  import integrationTeacherNotInCourseModal from 'components/modals/integrationTeacherNotInCourseModal';
  import { EventBus } from 'utils/event-bus';
  import adminServices from 'services/admin/adminServices';
  import getBillingInformation from 'services/account/getBillingInformation';


  export default {
    components: {
      IntegrationCard,
      integrationModal,
      googleClassroomModal,
      disconnectGoogleClassroomModal,
      integrationTeacherNotInCourseModal
    },
    data() {
      return {
        loading: false,
        google_classroom_connected: false,
        loading_to_disconnect: false,
        google_classroom_course_name: 'Findmore to change',
        google_classroom_modal: false,
        show_disconnect_classroom_modal: false,
        provider_selected:{},
        show_integration_modal: false,
        co_teachers_integration: null,
        memberships:{},
        provider_courses: [],
        update_roster: false,
        selected_integration: {},
        google_classroom_title:'Google Classroom',
        google_classroom_icon: '/static/google_class_round.png',
        google_classroom_code: 'google-classroom',
      };
    },
    computed: {
      ...mapGetters(['getProfile', 'getProviders','getCourseDetail']),
    },
    methods:{
      getIntegrationData(integration_id){
        const course_id= this.$route.params.courseID;
        this.$store.dispatch('getSsoIntegration', {course_id, integration_id}).then((res)=>{
          this.provider_selected=res;
        })
        .then(()=>{
          this.$store.dispatch('getSsoCourses', { course_id, integration_id}).then((res)=>{
            this.provider_courses=res;
          });
        }).then(() => this.show_integration_modal=true);
      },
      updateRoster(provider){
        const course_id= this.$route.params.courseID;
        this.provider_selected = provider;
        this.update_roster=true;
        const integration_id=provider.id || provider.integration_id;
        this.$store.dispatch('getSsoCourses', {course_id, integration_id})
          .then((res)=> {
            this.provider_courses = res;
            this.show_integration_modal = true;
          });
      },
      providers() {
        this.loading = true;
        const courseID= this.$route.params.courseID;
        this.$store.dispatch('getSsoCourseProviders', courseID)
          .then(() => this.loading = false)
          .catch(err => {
            console.error(err);
            this.loading = false;
          });
      },
      closeIntegrationModal(){
        this.show_integration_modal = false;
        if (this.$route.query.integrationID) {
          delete this.$route.query.integrationID;
        }
      },
      checkIntegrationTeachersInParlay(teachers) {
        const parlay_teachers_emails = this.getCourseDetail.users
          .filter((u) => ['co-teacher'].includes(u.subscription.role))
          .map((x) => x.email);
        const integration_teachers_emails = teachers.map(
          (t) => t.person ? t.person.email : t.profile.emailAddress
        );
        const missing_teachers = [];
        parlay_teachers_emails.forEach((email) => {
          if (!integration_teachers_emails.includes(email)) {
            missing_teachers.push(email);
          }
        });
        return missing_teachers;
      },
    },
    created() {
      getBillingInformation()
        .then((res) => {
          const { memberships } = res.data;
          this.memberships = memberships;
        });
    },
    mounted() {
      this.providers();
      if(this.$route.query.integrationID){
        const integration_id = this.$route.query.integrationID;
        this.getIntegrationData(integration_id);
        this.$store.dispatch('updateProviders', {
          integration_id,
          connect: true,
        });
        adminServices.setSsoIntegrationProfile(integration_id).then(({data}) => {
          if (data){
            const edlink_integrations = this.getProfile.edlink_integrations;
            edlink_integrations.push(data);
            this.$store.dispatch('updateAccount', { edlink_integrations });
          }
        });

      }

      EventBus.$on('show-integration-courses', (integrationID) => {
        this.getIntegrationData(integrationID);
      });
      EventBus.$once('open-coteachers-integration-alert', (teachers,integration) => {
        const int_teachers = this.checkIntegrationTeachersInParlay(teachers);
        if (int_teachers.length){
          integration.teachers = int_teachers;
        }
        this.co_teachers_integration = integration;
      });
    },
    beforeDestroy(){
      EventBus.$off('show-integration-courses');
      EventBus.$off('open-coteachers-integration-alert');
    }
  };
</script>
<style scoped lang="stylus">
  @import '~app/global-stylus.styl'
</style>



// WEBPACK FOOTER //
// integrations.vue?4e5bbdf0